import React from 'react';

const MenuTitle = () => {
  return (
    <div className="menu-widget__widget-title-container">
      <div className="menu-widget__widget-title">Menu</div>
    </div>
  );
};

export default MenuTitle;
